var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{staticClass:"app-footer"},[_c('p',[_vm._v("Desarrollado por "),_c('a',{attrs:{"href":"https://nayra.coop","target":"_blank"}},[_vm._v("nayra.coop")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-441e2fce","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/containers/AppFooter.vue
// module id = 217
// module chunks = 0